/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * Sends a legacy /en/… address to the same page without the prefix (N-3).
 *
 * English addresses have no language prefix. An old link or e-mail can still
 * carry /en/, and without this route "/en/auth" was read as an article
 * address (/:articleSlug/:detailedArticleSlug), which asked the back end for
 * an article called "auth" and showed "We couldn't load this page" - with the
 * header and footer hidden too, because the path still contained /auth.
 *
 * The query string and the fragment are kept: /en/auth?redirect=… must reach
 * /auth?redirect=…, and /en/screen-recorder#faq must keep #faq.
 *
 * The route that renders this (routes/englishPrefixRoutes.tsx) is registered
 * in main.tsx WITHOUT AddLangToPath, at the top level of the route table: it
 * must exist whatever language the page was opened in. A static first segment ("en")
 * outranks the dynamic product and article patterns, so nothing else changes.
 */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { stripLanguagePrefix } from "@/utils/localizedPath";

const DropEnglishPrefix: React.FC = () => {
  const { pathname, search, hash } = useLocation();
  return (
    <Navigate to={`${stripLanguagePrefix(pathname)}${search}${hash}`} replace />
  );
};

export default DropEnglishPrefix;
